import { Tooltip, Box } from "@mui/material";
import colors from "../../../../theme/Colours";
import {
  LargeBoldText,
  RegularText,
  SemiBoldText,
  StyledKpiCard,
} from "../styles";

export default function KpiCard({
  key,
  label,
  helperText,
  value,
  isPositive = null,
  valueColor,
}: {
  key?: string;
  label: string;
  helperText: string;
  value: string;
  isPositive?: boolean | null;
  valueColor?: string;
}) {
  let helperColor = colors.black;
  if (isPositive === true) helperColor = colors.progressColorKpi;
  else if (isPositive === false) helperColor = colors.regressColorKpi;

  const isOutstanding = label === "Outstanding";

  const tooltipContent =
    valueColor === "#00B207"
      ? "Credit Advance"
      : valueColor === "#FF0000"
        ? "Outstanding pending"
        : "No outstanding amount";

  const tooltipColor =
    valueColor === "#00B207"
      ? colors.progressColorKpi
      : valueColor === "#FF0000"
        ? colors.regressColorKpi
        : colors.kpiCardNumbers;

  const valueComponent = (
    <LargeBoldText color={valueColor ?? colors.kpiCardNumbers}>
      {value}
    </LargeBoldText>
  );

  return (
    <StyledKpiCard key={`dashboard_kpi_${key}`}>
      <SemiBoldText color={colors.kpiCardLabels}>{label}</SemiBoldText>

      {/* 👇 Wrap ONLY Outstanding value in tooltip */}
      {isOutstanding ? (
        <Tooltip
          arrow
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: "rgba(255,255,255,0.9)", // 👈 white translucent
                color: "#1F2937", // dark text
                boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                borderRadius: "8px",
                padding: "8px 12px",
              },
            },
            arrow: {
              sx: {
                color: "rgba(255,255,255,0.9)", // 👈 match tooltip bg
              },
            },
          }}
          title={
            <Box display="flex" alignItems="center" gap="6px">
              <span style={{ color: tooltipColor, fontSize: 16 }}>●</span>
              <span>{tooltipContent}</span>
            </Box>
          }
        >
          <span style={{ display: "inline-block" }}>{valueComponent}</span>
        </Tooltip>
      ) : (
        valueComponent
      )}

      <RegularText style={{ color: helperColor }}>{helperText}</RegularText>
    </StyledKpiCard>
  );
}
